export default () => {
  RegExp.escape = (s) => s.replace(/[-/\\^$+*?.()|[\]{}]/g, '\\$&');
  const searchInput = document.getElementById('search');
  const searchDelete = document.getElementById('search_delete');
  const contrAgents = document.querySelectorAll('.catalog-list li');
  const searchValue = () => {
    const value = searchInput.value;
    if (value !== '') {
      searchDelete.classList.remove('is-hidden');
      const regx = new RegExp(`${RegExp.escape(searchInput.value)}`,'i');
      [...contrAgents].map(agent=>agent.classList.add('is-hidden'));
      let sorted = [];
      if (value[0] === '+'){
        sorted = [...contrAgents].filter(agent => regx.test(document.getElementById('phone-' + agent.id).innerText));
      } else {
        sorted = [...contrAgents].filter(agent => regx.test(document.getElementById('name-' + agent.id).innerText));
      }
      [...sorted].map(agent=>agent.classList.remove('is-hidden'));
    } else {
      [...contrAgents].map(agent=>agent.classList.remove('is-hidden'));
      searchDelete.classList.add('is-hidden');
    }
  };

  searchInput.oninput = () => searchValue();
  searchDelete.onclick = () => {
    searchInput.value = '';
    searchValue();
  }
}
